import { useTranslation } from 'react-i18next';

import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

import { TEAM_ROW_HEIGHT } from './TeamInfoRow';

export const TieInfoRow = () => {
    const { t } = useTranslation('sbk_matchup_card');
    return (
        <Row height={TEAM_ROW_HEIGHT} alignItems="center">
            <Text variant="titleMedium" color={ds.colorToken.text.primary} numberOfLines={1}>
                {t('draw')}
            </Text>
        </Row>
    );
};
